import { Row, Col, FormGroup, Label, Input, FormFeedback, Button, } from "reactstrap";
import PreviewFeePaymentURL from "./PreviewFeePaymentURL";
import api from "../api";
import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import "../styles/form-details.css";


export default function FormDetails({ formik }) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
  } = formik;
  const [slugStatus, setSlugStatus] = useState("");

  // Title change → update title + slug + check availability
  const handleTitleChange = async (e) => {
    const title = e.target.value;
    setFieldValue("title", title);

    const slug = title
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

    setFieldValue("slug", slug);

    if (slug) {
      try {
        const token = localStorage.getItem("jwt");
        const res = await api.post(`/forms/exist/${slug}`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data === true) {
          formik.setFieldTouched("slug", true, false);
          formik.setFieldError("slug", "This URL is already in use. Please choose another.");
          setSlugStatus("");
        } else {
          formik.setFieldError("slug", undefined);
          setSlugStatus("Great! This URL is available and ready to use.");
        }
      } catch (err) {
        setSlugStatus("Error checking URL availability");
      }
    } else {
      setSlugStatus("");
    }
  };

  // Slug change → check availability
  const handleSlugChange = async (slug) => {
    setFieldValue("slug", slug);

    if (slug) {
      try {
        const token = localStorage.getItem("jwt");
        const res = await api.post(`/forms/exist/${slug}`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data === true) {
          formik.setFieldError("slug", "This URL is already in use. Please choose another.");
          setSlugStatus("");
        } else {
          formik.setFieldError("slug", undefined);
          setSlugStatus("Great! This URL is available and ready to use.");
        }
      } catch (err) {
        setSlugStatus("Error checking slug");
      }
    } else {
      setSlugStatus("");
    }
  };

  return (
    <Row>
      {/* Title */}
      <Col md="6">
        <FormGroup>
          <Label className="form-label">Title (Brand Name) *</Label>
          <Input
            name="title"
            value={values.title || ""}
            onChange={handleTitleChange}
            onBlur={handleBlur}
            invalid={touched.title && !!errors.title}
            placeholder="Enter brand name"
          />
          <FormFeedback>{touched.title && errors.title}</FormFeedback>
        </FormGroup>
      </Col>

      {/* Slug / Preview URL */}
      <Col md="6">
        <FormGroup>
          <PreviewFeePaymentURL
            baseUrl
            value={values.slug || ""}
            onChange={handleSlugChange}
            onBlur={() => setFieldTouched("slug", true)}
            required
            error={touched.slug && errors.slug}
            slugStatus={!errors.slug ? slugStatus : ""}
          />
          <FormFeedback>{touched.slug && errors.slug}</FormFeedback>
        </FormGroup>
      </Col>

      {/* Description */}
      <Col md="12">
        <FormGroup>
          <Label className="form-label">Description</Label>
          <Input
            type="textarea"
            name="description"
            value={values.description || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={250}
            placeholder="Enter a short description (max 250 chars)"
          />
        </FormGroup>
      </Col>

      {/* Contact Number */}
      <Col md="6">
        <FormGroup>
          <Label>
            Merchant Contact Number *
          </Label>

          <Input
            name="merchPhone"
            type="tel"
            value={values.merchPhone || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={10}
          />
        </FormGroup>
      </Col>

      {/* Email */}
      <Col md="6">
        <FormGroup>
          <Label>
            Merchant Email *
          </Label>

          <Input
            name="merchEmail"
            type="email"
            value={values.merchEmail || ""}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>

        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              checked={values.merchantNotification}
              onChange={(e) =>
                setFieldValue(
                  "merchantNotification",
                  e.target.checked
                )
              }
            />
            {" "}
            Send Email Notification to Merchant
          </Label>
        </FormGroup>
      </Col>
      {/* <Col md="12">
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              checked={
                values.stakeholderNotification
              }
              onChange={(e) =>
                setFieldValue(
                  "stakeholderNotification",
                  e.target.checked
                )
              }
            />
            {" "}
            Send Email Notification to External Stakeholders
          </Label>
        </FormGroup>
      </Col> */}
      {/* {
        values.stakeholderNotification && ( */}
      <Col md="6">
        <FormGroup>
          <Label>
            External Stakeholder Emails{" "}
            <span className="text-muted">(Optional)</span>
          </Label>

         {values.stakeholderEmails.map(
  (email, index) => (
    <div
      key={index}
      className="mb-2"
    >
      <div className="d-flex gap-2 align-items-start">
                <Input
                  type="email"
                  value={email}
                  placeholder="Enter stakeholder email"
                  invalid={
                    email &&
                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                  }
                  onChange={(e) => {
                    const updated = [
                      ...values.stakeholderEmails,
                    ];

                    updated[index] =
                      e.target.value;

                    setFieldValue(
                      "stakeholderEmails",
                      updated
                    );
                  }}
                />

                {values.stakeholderEmails
                  .length > 1 && (
                    <Button
                      type="button"
                      className="stakeholder-btn-delete"
                      size="sm"
                      onClick={() => {
                        setFieldValue(
                          "stakeholderEmails",
                          values.stakeholderEmails.filter(
                            (_, i) =>
                              i !== index
                          )
                        );
                      }}
                    >
                      <Trash2 size={14} />
                    </Button>
                  )}

                {index ===
                  values.stakeholderEmails
                    .length -
                  1 &&
                  values.stakeholderEmails
                    .length < 5 && (
                    <Button
                      type="button"
                      className="stakeholder-btn-add"
                      color="primary"
                      size="sm"
                      onClick={() =>
                        setFieldValue(
                          "stakeholderEmails",
                          [
                            ...values.stakeholderEmails,
                            "",
                          ]
                        )
                      }
                    >
                      <Plus size={14} />
                    </Button>
                  )}
              </div>
              
                {email &&
                  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
                    <FormFeedback className="d-block">
                      Please enter a valid email address
                    </FormFeedback>
                  )}
</div>
            )
          )}
        </FormGroup>
      </Col>
      {/* )
      } */}

      {/* Send Receipt on Email */}
      {/* <Col md="12">
        <FormGroup check>
          <Label check className="checkbox-label">
            <Input
              type="checkbox"
              name="customReceipt"
              checked={values.customReceipt === true}
              onChange={(e) => setFieldValue("customReceipt", e.target.checked)}
              onBlur={handleBlur}
            />{" "}
            Send receipt on email
          </Label>
        </FormGroup>
      </Col> */}
    </Row>
  );
}
